import { useEffect, useRef } from "react";
import { ArrowUp } from "lucide-react";
import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";

export default function LibrarySearchBar({
  value: externalValue,
  onChange: externalOnChange,
  onSearch,
  fullWidth = false,
  placeholder,
}) {
  // Use ref for direct DOM manipulation
  const inputRef = useRef(null);
  const navigate = useNavigate();
  
  // Sync the DOM input with React props when they change
  useEffect(() => {
    if (inputRef.current && externalValue !== undefined) {
      inputRef.current.value = externalValue;
    }
  }, [externalValue]);

  // Handle the submission of the search
  const handleSubmit = () => {
    // Get value directly from DOM
    const currentValue = inputRef.current?.value || "";
    
    if (!currentValue.trim()) return;

    // Call the search function provided by parent
    if (onSearch) {
      onSearch(currentValue);
    }

    // Clear the input
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    
    // Notify parent component
    if (externalOnChange) {
      externalOnChange("");
    }
  };

  // Handle key press events
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const placeholders = [
    "Come Marx vedeva il capitalismo?",
    "Qual è il ruolo dell'AI nella sanità moderna?",
    "Influenza dei social media sulla politica giovanile",
    "Differenze tra economia keynesiana e neoclassica",
    "Come si sviluppa il linguaggio nei bambini?",
    "Il cambiamento climatico nei romanzi distopici",
    "Analisi semiotica di una pubblicità famosa",
    "Storia del femminismo in Italia",
    "L'impatto della globalizzazione sulle PMI",
    "Tecniche di machine learning applicate alla biologia",
    "Filosofia del linguaggio: Wittgenstein vs. Saussure",
    "Effetti psicologici del lavoro da remoto",
    "Come la pandemia ha cambiato l'istruzione universitaria?",
    "L'evoluzione del diritto d'autore nell'era digitale",
    "Intelligenza artificiale e bias nei dati",
  ];

  const randomPlaceholder = useRef(
    placeholders[Math.floor(Math.random() * placeholders.length)]
  ).current;

  return (
    <div
      className={`w-full h-fit p-3 px-4 md:p-4 flex flex-row bg-white rounded-[12px] border-2 border-gray-100 hover:border-gray-200 transition-all text-[16px] font-rg ${
        fullWidth ? "" : "max-w-[760px]"
      }`}
    >
      <input
        ref={inputRef}
        placeholder={placeholder || randomPlaceholder}
        className="grow outline-none"
        type="text"
        defaultValue={externalValue}
        onKeyDown={handleKeyDown}
      />
      <Button
        size="sm"
        type="bw"
        icon={<ArrowUp size="16" color="black" />}
        onClick={handleSubmit}
      />
    </div>
  );
}